import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    padding: '3rem 2rem',
    marginBottom: '3rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 1rem',
    }
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '5rem',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      gap: '2rem',
      justifyContent: 'center',
    }
  },
  cardContentMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  contentContainer: {
    minWidth: '300px',
    maxWidth: '539px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    }
  },
  cardTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: '#091242',
    width: '100%',
    marginBottom: '1rem'
  },
  bulletList: {
    paddingLeft: '1.5rem',
    '& li': {
      marginBottom: '0.5rem'
    }
  },
  divider: {
    margin: '1rem 0'
  },
  benefitItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.7rem',
    marginBottom: '1rem'
  },
  actionContainer: {
    marginTop: '2rem',
    display: 'flex',
    alignItems: 'center',
    gap: '3rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '1rem'
    }
  },
  learnMoreBtn: {
    backgroundColor: '#005FAA',
    width: '255px',
    borderRadius: '2rem',
    '&:hover': {
      backgroundColor: '#004c87',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  cardImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '1rem'
    }
  },
  cardImageContainerMobile: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1rem'
  },
  cardImage: {
    width: '359px',
    height: 'auto',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '300px'
    }
  }
}))
